// extracted by mini-css-extract-plugin
export var whyOnlineBenefit = "infoCard-module--whyOnlineBenefit--60hcd";
export var whyOnlineDescription = "infoCard-module--whyOnlineDescription--GcNk2";
export var whyOnlineHead = "infoCard-module--whyOnlineHead--59zS9";
export var whyOnlineImage = "infoCard-module--whyOnlineImage--lfzW2";
export var whyOnlineTagline = "infoCard-module--whyOnlineTagline--Q+ZHo";